import { render, staticRenderFns } from "./route.vue?vue&type=template&id=4075f59a&scoped=true&"
import script from "./route.vue?vue&type=script&lang=js&"
export * from "./route.vue?vue&type=script&lang=js&"
import style0 from "./route.vue?vue&type=style&index=0&id=4075f59a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4075f59a",
  null
  
)

export default component.exports